var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"booking payment"},[_c('h3',[_vm._v(_vm._s(_vm._f("trans")('shopcart.payment_types')))]),_vm._v(" "),_c('ul',_vm._l((_vm.payments),function(ref){
var type = ref.type;
var image = ref.image;
var icon = ref.icon;
var title = ref.title;
var description = ref.description;
return _c('li',{key:type},[_c('div',[(!_vm.isNil(icon))?_c('i',{class:icon}):_c('img',{attrs:{"src":image}}),_vm._v(" "),_c('aside',[_c('h4',[_vm._v(_vm._s(_vm._f("trans")(title)))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm._f("trans")(description)))])])]),_vm._v(" "),_c('div',[_c('div',{class:{
                        'gl-radiobtn': true,
                        'checked': _vm.selected === type
                    }},[_c('button',{staticClass:"action",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.select(type, image, icon, title, description)}}})])])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ddb03a7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/sections/Payment.vue
// module id = null
// module chunks = 